import React from "react";

export default function DatePicker({
    startDate,
    endDate,
    onStartDateChange,
    onEndDateChange,
    minStartDate = null,
    maxPeriodInDays = 31,
}) {
    const getNextDay = (date) => {
        const newDate = new Date(date);
        newDate.setDate(newDate.getDate() + 1);
        return newDate.toISOString().split("T")[0];
    };

    const getPreviousDay = (date) => {
        const newDate = new Date(date);
        newDate.setDate(newDate.getDate() - 1);
        return newDate.toISOString().split("T")[0];
    };

    const calculateMinStartDate = (endDate) => {
        const newDate = new Date(endDate);
        newDate.setDate(newDate.getDate() - maxPeriodInDays);
        return newDate;
    };

    const calculateMaxEndDate = (startDate) => {
        const newDate = new Date(startDate);
        newDate.setDate(newDate.getDate() + maxPeriodInDays);
        return newDate;
    };

    const handleStartDateChange = (newStartDate) => {
        const newStart = new Date(newStartDate);
        const maxAllowedEndDate = calculateMaxEndDate(newStart);
        if (new Date(endDate) > maxAllowedEndDate) {
            onEndDateChange(maxAllowedEndDate.toISOString().split("T")[0]);
        }
        onStartDateChange(newStartDate);
    };

    const handleEndDateChange = (newEndDate) => {
        const newEnd = new Date(newEndDate);
        const minAllowedStartDate = calculateMinStartDate(newEnd);
        if (new Date(startDate) < minAllowedStartDate) {
            onStartDateChange(minAllowedStartDate.toISOString().split("T")[0]);
        }
        onEndDateChange(newEndDate);
    };

    return (
        <div className="row d-flex justify-content-end">
            <div className="col-auto d-flex mt-1 ps-0">
                <label className="me-1 align-self-center">Від:</label>
                <input
                    type="date"
                    value={startDate}
                    onChange={(e) => handleStartDateChange(e.target.value)}
                    className="form-control-sm bg-secondary border-0 text-white rounded-5"
                    style={{
                        WebkitTextFillColor: "white",
                    }}
                    min={
                        minStartDate
                            ? minStartDate.toISOString().split("T")[0]
                            : null
                    }
                    max={getPreviousDay(endDate)}
                />
            </div>
            <div className="col-auto d-flex mt-1 ps-0">
                <label className="me-1 align-self-center">До:</label>
                <input
                    type="date"
                    value={endDate}
                    onChange={(e) => handleEndDateChange(e.target.value)}
                    className="form-control-sm bg-secondary border-0 text-white rounded-5"
                    style={{
                        WebkitTextFillColor: "white",
                    }}
                    min={startDate ? getNextDay(startDate) : null}
                    max={new Date().toISOString().split("T")[0]}
                />
            </div>
        </div>
    );
}
